import { PrivacyCenterTrackingPurposePreview } from '@main/cm-types';

import { Purpose } from '../CommunicationsPreferences/components';
import { preferenceTopicsToDefaults } from '../CommunicationsPreferences/components/PurposeList';

/**
 * Create input for setting all communication purposes/preferences in the UI form
 *
 * @param consentStatus - consent status to set all purposes to
 * @param configuredCommunicationPurposes - Purposes configured for a particular organization
 * @returns input for setting all communication purposes/preferences
 */
export function getSetAllPreferencesInput(
  consentStatus: boolean,
  configuredCommunicationPurposes: PrivacyCenterTrackingPurposePreview[],
): Record<string, Purpose> {
  return configuredCommunicationPurposes.reduce(
    (acc, { trackingType, preferenceTopics }) => ({
      ...acc,
      [trackingType]: {
        consent: consentStatus,
        preferences: preferenceTopicsToDefaults(
          preferenceTopics || [],
          consentStatus,
        ),
      },
    }),
    {},
  );
}
